import { createSelector } from 'reselect';
import memoize from 'lodash/memoize';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import { selectFeatureFlags } from 'yoda-site-components/lib/selectors/ContextSelector';
import { initProductOptions } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import { promiseBopisNodes } from 'yoda-site-components/lib/common/ProductConstants';

const getDeliveryOptionsName = (state) => state.deliveryOptionsName || {};
const getProductOffering = (state) => state.productOffering || {};
const getBopusStoreNode = () => promiseBopisNodes.aggregatedBopusNode;

export const getMOQDropdownValue = memoize((sourceMiniPDP) =>
    createSelector(
        [
            selectFeatureFlags,
            getDeliveryOptionsName,
            initProductOptions(sourceMiniPDP),
            getProductOffering,
        ],
        (featureFlags, deliveryOptionsName, productOptions, promise) => {
            let returnValue = 25;
            const lotMaxQuantity = get(productOptions, 'selectedLotDetails.maxQuantity', 8);
            if (get(featureFlags, 'enableMOQDropdownLogic', true)) {
                if (productOptions?.pricingURL?.itemOfferingCall) {
                    const deliveryOptions = get(
                        promise,
                        'promise.skuDeliveryOptions[0].deliveryOptions',
                        null
                    );
                    if (deliveryOptions && deliveryOptionsName.selectedOption === 'shiptohome') {
                        const availableQuantity = get(
                            deliveryOptions,
                            'shipToHome.availableQuantity'
                        );
                        if (isNil(availableQuantity) || availableQuantity > lotMaxQuantity) {
                            returnValue = lotMaxQuantity;
                        } else {
                            returnValue = availableQuantity;
                        }
                    } else if (
                        deliveryOptions &&
                        deliveryOptionsName.selectedOption === 'samedaypickup'
                    ) {
                        const availableQuantity = get(
                            deliveryOptions,
                            `${getBopusStoreNode()}.locationIds[0].availableQuantity`
                        );
                        if (isNil(availableQuantity) || availableQuantity > lotMaxQuantity) {
                            returnValue = lotMaxQuantity;
                        } else {
                            returnValue = availableQuantity;
                        }
                    } else {
                        returnValue = lotMaxQuantity;
                    }
                } else {
                    returnValue = lotMaxQuantity;
                }
            } else {
                returnValue = lotMaxQuantity;
            }
            return returnValue;
        }
    )
);

export default getMOQDropdownValue;
